import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from './components/ui/sonner';

// Remove Emergent badge
const removeEmergentBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.remove();
  }
  // Also remove any links to emergent.sh
  const emergentLinks = document.querySelectorAll('a[href*="emergent.sh"]');
  emergentLinks.forEach(link => link.remove());
};

// Run on load and after DOM changes
window.addEventListener('load', removeEmergentBadge);
setTimeout(removeEmergentBadge, 100);
setTimeout(removeEmergentBadge, 500);
setTimeout(removeEmergentBadge, 1000);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>
);